/**
 * 発注（積替・搬入）
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/requests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      selectedStatus: null,
      requestNo: null,
      keyword: null,
      driverId: null,
      driverName: null,
      requestDateType: null,
      requestStartDate: null,
      requestEndDate: null,
      orderType: null,
      carryInStartDate: null,
      carryInEndDate: null,
    },
  }
}

const order_request = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
    * 発注一覧
    * @param dispatch
    * @param commit
    * @param state
    * @param name
    * @param subscriber_number
    *
    * @param selectedStatus
    * @param keyword
    * @param requestNo
    * @param driverId
    * @param driverName
    * @param requestDateType
    * @param requestStartDate
    * @param requestEndDate
    * @param orderType
    * @param carryInStartDate
    * @param carryInEndDate
    *
    * @param page
    * @param limit
    * @return {Promise<unknown>}
    */
    index ({ dispatch, commit, state }, { selectedStatus, requestNo, keyword, driverId, driverName, requestDateType, requestStartDate, requestEndDate, orderType, carryInStartDate, carryInEndDate, page, limit, format }) {
      dispatch('saveCondition', {
        selectedStatus: selectedStatus,
        requestNo: requestNo,
        keyword: keyword,
        driverId: driverId,
        driverName: driverName,
        requestDateType: requestDateType,
        requestStartDate: requestStartDate,
        requestEndDate: requestEndDate,
        orderType: orderType,
        carryInStartDate: carryInStartDate,
        carryInEndDate: carryInEndDate,
        limit: limit,
      })
      const params = {
        selectedStatus: state.condition.selectedStatus,
        requestNo: state.condition.requestNo,
        keyword: state.condition.keyword,
        driverId: state.condition.driverId,
        driverName: state.condition.driverName,
        requestDateType: state.condition.requestDateType,
        requestStartDate: state.condition.requestStartDate,
        requestEndDate: state.condition.requestEndDate,
        orderType: state.condition.orderType,
        carryInStartDate: state.condition.carryInStartDate,
        carryInEndDate: state.condition.carryInEndDate,
        limit: limit,
        page: page,
      }
      return new Promise((resolve) => {
        const api_path = format === 'csv' ? `${API_PATH}.csv` : `${API_PATH}`
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format != 'csv') {
            let content = data.content
            commit(types.DRIVER_ORDER_REQUEST_PAGINATION, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    /**
    * 受注詳細
    * @param commit
    * @param id
    * @return {Promise<unknown>}
    */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showMultiInfo', { message: `登録しました,引取搬入番号: ${content.request_no}` }, { root: true })
          resolve(content)
        })
      })
    },
    destroy ({ commit },{ id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path, id).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        })
      })
    },
    saveCondition ({ commit, state }, { selectedStatus, requestNo, keyword, driverId, driverName, requestDateType, requestStartDate, requestEndDate, orderType, carryInStartDate, carryInEndDate, limit }) {
      const _selectedStatus = (selectedStatus !== undefined) ? selectedStatus : state.condition.selectedStatus
      const _requestNo = (requestNo !== undefined) ? requestNo : state.condition.requestNo
      const _keyword = (keyword !== undefined) ? keyword : state.condition.keyword
      const _driverId = (driverId !== undefined) ? driverId : state.condition.driverId
      const _driverName = (driverName !== undefined) ? driverName : state.condition.driverName
      const _requestDateType = (requestDateType !== undefined) ? requestDateType : state.condition.requestDateType
      const _requestStartDate = (requestStartDate !== undefined) ? requestStartDate : state.condition.requestStartDate
      const _requestEndDate = (requestEndDate !== undefined) ? requestEndDate : state.condition.requestEndDate
      const _orderType = (orderType !== undefined) ? orderType : state.condition.orderType
      const _carryInStartDate = (carryInStartDate !== undefined) ? carryInStartDate : state.condition.carryInStartDate
      const _carryInEndDate = (carryInEndDate !== undefined) ? carryInEndDate : state.condition.carryInEndDate
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = {
        selectedStatus: _selectedStatus,
        requestNo: _requestNo,
        keyword: _keyword,
        driverId: _driverId,
        driverName: _driverName,
        requestDateType: _requestDateType,
        requestStartDate: _requestStartDate,
        requestEndDate: _requestEndDate,
        orderType: _orderType,
        carryInStartDate: _carryInStartDate,
        carryInEndDate: _carryInEndDate,
        limit: _limit
      }
      commit(types.DRIVER_ORDER_REQUEST_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_ORDER_REQUEST_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_ORDER_REQUEST_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_ORDER_REQUEST_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_ORDER_REQUEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_ORDER_REQUEST_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_ORDER_REQUEST_CONDITION] (state, { params }) {
      state.condition.selectedStatus = params.selectedStatus
      state.condition.requestNo = params.requestNo
      state.condition.keyword = params.keyword
      state.condition.driverId = params.driverId
      state.condition.driverName = params.driverName
      state.condition.requestDateType = params.requestDateType
      state.condition.requestStartDate = params.requestStartDate
      state.condition.requestEndDate = params.requestEndDate
      state.condition.orderType = params.orderType
      state.condition.carryInStartDate = params.carryInStartDate
      state.condition.carryInEndDate = params.carryInEndDate
      state.condition.limit = params.limit
    }
  },

}

export default order_request
